import { smartDocEHRParam_EHRType_Epic, smartDocParamType_EHR } from './types.js';
export const defaultItem_SmartDocEHRParam = (key) => ({
    key,
    type: smartDocParamType_EHR,
    resolver: {},
});
export const smartDocEHRParam_EHRTypeLabelMap = {
    [smartDocEHRParam_EHRType_Epic]: 'Epic',
};
//# sourceMappingURL=consts.js.map